<script setup lang="ts">
import SiteSection from '@/client/components/SiteSection.vue';
import type { FaqContent } from '@/client/types';

defineProps<{
    id: string;
    content: FaqContent;
}>();
</script>

<template>
    <SiteSection :id="id" :title="content.title">
        <div class="divide-y rounded-2xl border">
            <details v-for="(item, index) in content.items" :key="index" class="group p-5">
                <summary class="flex cursor-pointer list-none items-center justify-between gap-4 font-medium">
                    {{ item.question }}
                    <span class="text-muted-foreground transition-transform group-open:rotate-45">+</span>
                </summary>
                <p class="mt-3 whitespace-pre-line text-muted-foreground">{{ item.answer }}</p>
            </details>
        </div>
    </SiteSection>
</template>
